var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeerReviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09685 12.7363H8.51493L11.892 9.3554C11.9472 9.29209 11.9885 9.22578 12.0159 9.15648C12.0432 9.08675 12.0569 9.01767 12.0569 8.94922C12.0569 8.88078 12.0432 8.81319 12.0159 8.74646C11.9885 8.6793 11.9483 8.61406 11.8952 8.55075L11.3017 7.94117C11.2469 7.88598 11.1832 7.8447 11.1105 7.81732C11.0382 7.78995 10.9667 7.77626 10.8962 7.77626C10.8277 7.77626 10.7593 7.78781 10.6908 7.81091C10.6224 7.83443 10.5567 7.87785 10.4938 7.94117L7.09685 11.3189V12.737V12.7363ZM10.8923 9.57485L10.2827 8.96912L10.8962 8.35568L11.4897 8.96527L10.8923 9.57485ZM10.5811 12.7363H14.3028V12.0947H11.2228L10.5811 12.7363ZM4.9248 16.8828V6.96134C4.9248 6.66617 5.02384 6.41977 5.2219 6.22214C5.41953 6.02408 5.66593 5.92505 5.9611 5.92505H15.4385C15.7337 5.92505 15.9801 6.02408 16.1777 6.22214C16.3758 6.41977 16.4748 6.66617 16.4748 6.96134V13.8721C16.4748 14.1673 16.376 14.4139 16.1784 14.6119C15.9803 14.8096 15.7337 14.9084 15.4385 14.9084H6.89921L4.9248 16.8828Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeerReviewIcon);
export default __webpack_public_path__ + "static/media/peerReviewIcon.49d76bbae5a317625acd1a3756c3eade.svg";
export { ForwardRef as ReactComponent };